import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { LangUpdateService } from './lang-update.service';

@Injectable({
  providedIn: 'root'
})
export class CommonSnackBarService {

  isDismiss = false;
  timer: NodeJS.Timeout;

  constructor(
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    private langService: LangUpdateService
  ) {
    this.langService.prepare(this, this.translate);
  }

  /** スナックバーを表示する
   * @param {string} message
   * @param {string=null} action
   * @param {number=3000} duration
   */
  open(message: string, panelClass: string = null, action: string = null, duration: number = 3000): boolean {
    const config = new MatSnackBarConfig();
    config.panelClass = panelClass ? [panelClass] : [];
    config.duration = duration;
    this.snackBar.open(message, action, config);
    return true;
  }
}
